export default __webpack_public_path__ + "static/media/luke600.86c5fbff.jpg";